import React from 'react';
import { NextPages } from '@autovia-uk/polaris-components/components/molecules/NextPages';

export const getInThisArticle = (
  title = 'Continue Reading',
  currentPageUrl = null,
  multipage = null,
  currentlyReadingLabel = '',
) => {
  if (multipage === null || (Array.isArray(multipage) && multipage.length === 0)) {
    return false;
  }

  return (
    <NextPages
      title={title}
      currentPageUrl={currentPageUrl}
      currentlyReadingLabel={currentlyReadingLabel}
      content={multipage.map(el => ({
        url: el.url,
        title: el.title,
        rating: el.rating || false,
        subtitle: el.subtitle || false,
      }))}
      showRating
      ratingPosition="after-title"
      showIcon
      showIndex={false}
    />
  );
};
